import mapActions from './mapActions';

export default mapActions('today_info', {
	fetchAll_url: (date) => `/api/working_hours/today_info/${date}`
});